import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollService, SCROLL_SERVICE } from './scroll-service';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: SCROLL_SERVICE,
      useClass: ScrollService,
    },
  ],
})
export class SharedSchedulesFeatureScheduleEditorModule {}
